/* global axios */

import ApiClient from './ApiClient';

class SeatOrders extends ApiClient {
  constructor() {
    super('seat_orders', { accountScoped: true });
  }

  getConfig(productKey) {
    return axios.get(`${this.url}/price_config`, {
      params: { product_key: productKey },
    });
  }

  getPlanConfig() {
    return axios.get(`${this.url}/plan_config`);
  }

  createOrder({ quantity, parentOrigin, productKey, productNo, orderType }) {
    return axios.post(this.url, {
      seat_order: {
        quantity,
        parent_origin: parentOrigin,
        product_key: productKey,
        product_no: productNo,
        order_type: orderType,
      },
    });
  }

  getOrders(params = {}) {
    return axios.get(this.url, { params });
  }

  // 申请发票
  applyInvoice(orderNo, data) {
    return axios.post(`${this.url}/${orderNo}/apply_invoice`, data);
  }

  // 获取发票状态
  getInvoiceStatus(orderNo) {
    return axios.get(`${this.url}/${orderNo}/invoice_status`);
  }

  // 获取升级预览（余额抵扣计算）
  getUpgradePreview(productNo, quantity = 1) {
    return axios.get(`${this.url}/upgrade_preview`, {
      params: { product_no: productNo, quantity },
    });
  }
}

export default new SeatOrders();
